import type { IAdSlotRegistry } from '../types/ad-manager.interfaces';
import type { IDefinedSlot } from '../types/google-tag.types';
import { BannerType } from '../types/google-tag.types';

export class AdSlotRegistry implements IAdSlotRegistry {
	private readonly slots: Map<BannerType, IDefinedSlot[]> = new Map([
		[BannerType.TOP, []],
		[BannerType.ADVANCED, []],
		[BannerType.MOBILE_ADVANCED, []],
	]);

	private readonly registeredIds = new Set<string>();

	register(type: BannerType, slot: IDefinedSlot): void {
		const containerId = slot.getSlotElementId();
		if (this.registeredIds.has(containerId)) {
			console.warn(`[AdSlotRegistry] Slot "${containerId}" already registered — skipping.`);
			return;
		}
		this.registeredIds.add(containerId);

		let group = this.slots.get(type);
		if (!group) {
			group = [];
			this.slots.set(type, group);
		}
		group.push(slot);
	}

	getSlots(type: BannerType): IDefinedSlot[] {
		return this.slots.get(type) ?? [];
	}

	hasSlot(containerId: string): boolean {
		return this.registeredIds.has(containerId);
	}

	clear(): void {
		for (const group of this.slots.values()) {
			group.length = 0;
		}
		this.registeredIds.clear();
	}
}
